import React , {useEffect, useState} from "react";
import * as s from "./Profile.style";

import { Formik, Form } from "formik";
import FormikControl from "../../components/shared/inputs/FormikControl";
import * as Yup from "yup";
import { useDispatch , useSelector } from "react-redux";
import * as action from '../../store/actions/index';

const Profile = () => {
  let dispatch = useDispatch();

  let adminDataLoading = useSelector((state) => state.myinfo.loading)

  let adminData = useSelector((state) => state.myinfo.data);

  useEffect(() =>{
    dispatch(action.fetchUserInfo())
  },[])

 
  

  const [formValues , setFormValues] = useState(null)

  useEffect(() =>{
    if(adminDataLoading ===false){
      setFormValues({
    firstName: adminData.first_name,
    lastName: adminData.last_name,
    email: adminData.email,
    phoneNumber: adminData.phone_number,
    password: "",
    conpassword: "",

      })
    }
  },[adminDataLoading])

  const initialValues = {
    firstName:  "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    newPassword: ""
    
  };

  const passwordValues = {
    password: "",
    newPassword: ""
  };

 
  // console.log(adminData);
  
  
 

  const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const validationSchema = Yup.object({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email format").required("Required"),
  phoneNumber: Yup.string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("Required")
    .min(0),
  password: Yup.string().required("Required"),
  newPassword: Yup.string()
    .oneOf([Yup.ref("password"), ""], "Passwords must match")
    .required("Required"),
});

const togglePassword = () => {
  const togglePassword = document.querySelector("#togglePassword");
  const password = document.querySelector("#password");

  const type =
  password.getAttribute("type") === "password" ? "text" : "password";
password.setAttribute("type", type);
// toggle the eye slash icon
togglePassword.classList.toggle("fa-eye-slash");
};



const toggleConPassword = () => {
  const toggleConPassword = document.querySelector("#toggleConPassword");
  const password = document.querySelector("#conpassword");

  // toggle the type attribute
  const type =
    password.getAttribute("type") === "password" ? "text" : "password";
  password.setAttribute("type", type);
  // toggle the eye slash icon
  toggleConPassword.classList.toggle("fa-eye-slash");
};



const onSubmit = (initialValues) => {
  const {password , newPassword,...data} = initialValues;
  console.log("Form data", data);
  dispatch(action.updateUserInfo(data , data.firstName , data.lastName ))

};

const onSubmitPassword = (passwordValues) => {
  console.log( passwordValues)
  dispatch(action.updatePassword(passwordValues));
}


  return (
    <div>
      <s.ScreenContainer>
        {adminDataLoading === false ?(
          <s.Container>
          <s.HeaderContainer>
            <s.H1>My Profile</s.H1>
            <s.ImageContainer>
              <s.Image src={adminData.image_link}></s.Image>
              <s.ImageChange>
              
              </s.ImageChange>
            </s.ImageContainer>
            </s.HeaderContainer>
           
  
        <s.FormContainer>
            
            <Formik
              initialValues={ formValues || initialValues}
              // validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize 
            >
              {(formik) => {
                return (
                 
                  
                  <Form>
                    
                    <s.InfoContainer>
                      <FormikControl
                       
                        control="input"
                        // control='chakraInput'
                        type="text"
                        name="firstName"
                        placeholder="ROMAN"
                        
                      />
                      
                    
                      
                      <FormikControl
                        control="input"
                        // control='chakraInput'
                        type="text"
                        name="lastName"
                        placeholder="PROTOLIUK"
                        
                      />
                      
                    
                 
                      <FormikControl
                       
                        control="input"
                        // control='chakraInput'
                        type="email"
                        name="email"
                        placeholder="EMAIL"
                        
                      />
                      
                    
                      
                      <FormikControl
                        control="input"
                        // control='chakraInput'
                        type="text"
                        name="phoneNumber"
                        placeholder="PHONE NUMBER"
                       
                      />
  
                    
                      
                    </s.InfoContainer>
                    <s.updateContainer>
                      <s.UpdateBtn type="submit" disabled={!formik.isValid}>
                        Update
                      </s.UpdateBtn>
                    </s.updateContainer>

                    </Form>
                );
                }}
                </Formik>
                <Formik
                    initialValues={passwordValues}
                    // validationSchema={validationSchema}
                    onSubmit={onSubmitPassword}
                    
                >
                {(formik) => {
                return (

                  <Form>
  
                    <s.passwordContainer>
                    <s.InputContainer>
                      <FormikControl
                       
                        control="input"
                        // control='chakraInput'
                        type="password"
                        name="password"
                        id="password"
                        placeholder="OLD PASSWORD"
                      />

                      <s.Eye
                      className="far fa-eye"
                      onClick={togglePassword}
                      id="togglePassword"
                    ></s.Eye>
                      </s.InputContainer>
                    
                      <s.InputContainer>
                      <FormikControl
                        control="input"
                        // control='chakraInput'
                        type="password"
                        name="newPassword"
                        id="conpassword"
                        placeholder="NEW PASSWORD"
                      />
                      <s.Eye
                      className="far fa-eye"
                      onClick={toggleConPassword}
                      id="toggleConPassword"
                    ></s.Eye>
                      </s.InputContainer>
                      </s.passwordContainer>
                      <s.updateContainer>
                      <s.UpdateBtn type="submit"
                       disabled={!formik.isValid}
                       
                       >
                        Update Password
                      </s.UpdateBtn>
                    </s.updateContainer>

                    </Form>
                    );
                  }}
                    </Formik>
                
              </s.FormContainer>
        </s.Container>

        ) : null}
        
      </s.ScreenContainer>
    </div>
  );
};

export default Profile;


